import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from "react-router-dom";
import { GetKey, GetText } from '../../../Helpers/GetKey';
import PlantillaScreen from '../../helpers/PlantillaScreen';
import { LoaderScreen } from '../../components/LoaderScreen';
import request from '../../../Helpers/API';
import Swal from 'sweetalert2';
import { Box, Tab, Tabs } from "@mui/material";
import CustomTabPanel from '../../components/TabPanels/CustomTabPanel';
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import ArticleIcon from "@mui/icons-material/Article";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { ReestructurarCreditoCondicionesTab } from './ReestructurarCreditoCondicionesTab';
import { ReestructurarCreditoFinanciamientoTab } from './ReestructurarCreditoFinanciamientoTab';
import SendIcon from '@mui/icons-material/Send';


const ReestructurarCreditoCondicionesScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const clienteselect = location.state.cliente
    const folio = location.state.folio
    const cliente = GetText(clienteselect)
    const idcliente = GetKey(clienteselect)
    const [folioReestructuracion, setFolioReestructuracion] = useState("")
    const [condiciones, setCondiciones] = useState({})
    const [value, setValue] = useState(0);
    const [detalleFinanciamiento, setDetalleFinanciamiento] = useState([])
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });





    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`ReestructurarCredito/CrearReestructuracion?folio=${folio}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setFolioReestructuracion(result.folio)
                // setCondiciones(result.condiciones);
                // setDetalleFinanciamiento(result.detalles_financiamiento)
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire(
                    "VALIDAR CONDICIONES DE LA OPERACION",
                    JSON.stringify(error),
                    "error"
                );
            });
    }, []);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const onRegresar = (folio) => {
        history.push({
            pathname: "/Credito/ReestructurarCredito",
            state: {
                cliente: clienteselect,
                folio: folio
            },
        });
    }

    const onEnviar = () => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(
                `ReestructurarCredito/enviarRevision?folio=${folioReestructuracion}`
            )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });

                history.push("/SolicitudCredito/Main");
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("REESTRUCTURACION DE CREDITO", JSON.stringify(error), "error");
            });
    };

    return (
        <PlantillaScreen
            titulo={`REESTRUCTURAR CREDITO ${clienteselect !== "" ? "-" + GetText(clienteselect) : ""}`}
            className_main={1}
            className={"reestructuracion-credito-main-screen"}
        >
            <LoaderScreen loader={loader} />

            <div className="reestructurar-credito-boton-regresar-container">
                <button
                    className="reestructurar-credito-boton-regresar "
                    onClick={() => onRegresar()}
                >
                    <ArrowBackIcon />
                    REGRESAR
                </button>
            </div>

            <Box className="reestructuracion-credito-info-solicitud-container">
                <Box sx={{ borderRight: 1, borderColor: "divider" }} className="reestructuracion-credito-tabs-container">
                    <Tabs value={value} onChange={handleChange} variant="fullWidth" orientation='vertical'>
                        {/* <Tab
                            className='a'
                            // sx={{ height: '200px', fontSize: '16px' }}
                            icon={<AccountCircleIcon />}
                            label="Datos del Solicitante"
                        /> */}
                        <Tab
                            className={value === 0 ? 'a c' : 'a'}
                            // disabled={statePedido.unidadesvendidas}
                            icon={<AgricultureIcon />}
                            label="Condiciones de Credito"
                        />
                        <Tab
                            className={value === 1 ? 'c' : 'b'}
                            // disabled={statePedido.condicionescredito}
                            icon={<ArticleIcon />}
                            label="Detalles de Financiamiento"
                        />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <ReestructurarCreditoCondicionesTab
                        setValue={setValue}
                        folio={folioReestructuracion}
                    // setScreen={setScreen}
                    // screen={screen}
                    // setBottonguardar={setBottonguardar}
                    />
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <ReestructurarCreditoFinanciamientoTab
                        value={value}
                        folio={folioReestructuracion}
                    // screen={screen}
                    // setScreen={setScreen}
                    // setBottonguardar={setBottonguardar}
                    />
                </CustomTabPanel>
            </Box >
            <div className='reestructuracion-credito-enviar-revision-container'>
                <div
                    className='reestructuracion-credito-enviar-revision'
                    onClick={() => onEnviar()}
                >
                    Enviar a Revisión
                    <SendIcon />
                </div>
            </div>
        </PlantillaScreen>
    )
}

export default ReestructurarCreditoCondicionesScreen